export default "__VITE_ASSET__BN4hlmpn__"